import type { QTableColumn } from 'quasar';
import { formatDate } from 'src/utils/formatDate';
export interface GroupModelCreateAttributes {
  name: string;
  code: string;
  group_type_id: string;
  parent_id: string | '';
  description: string;
}
export interface GroupModelUpdateAttributes {
  name: string;
  code: string;
  group_type_id: string;
  parent_id: string | '';
  description: string;
}
export interface GroupModelAttributes {
  id: string;
  name: string;
  code: string;
  group_type: {
    id: string;
    name: string;
  };
  parent: {
    id: string;
    name: string;
  } | null;
  description: string;
  path_items: PathItem[];
  created_at: string;
  updated_at: string;
}
type PathItem = {
  id: string;
  name: string;
};
export class GroupModel {
  id: string;
  name: string;
  code: string;
  group_type: {
    id: string;
    name: string;
  };
  parent: {
    id: string;
    name: string;
  } | null;
  description: string;
  path_items: PathItem[];
  created_at: string;
  updated_at: string;

  constructor(input?: GroupModelAttributes) {
    this.id = input ? input.id : '';
    this.name = input ? input.name : '';
    this.code = input ? input.code : '';
    this.group_type = input ? input.group_type : { id: '', name: '' };
    this.description = input ? input.description : '';
    this.path_items = input ? input.path_items : [];
    this.created_at = input ? formatDate(input.created_at) : '';
    this.updated_at = input ? formatDate(input.updated_at) : '';
    this.parent = input ? input.parent : null;
  }

  getId(): string {
    return this.id;
  }
  getParentId(): string {
    if (this.path_items.length <= 0) {
      return '';
    }
    return this.path_items.slice(-1)[0]['id'];
  }
  getCreateAttributes(): GroupModelCreateAttributes {
    return {
      name: this.name,
      code: this.code,
      group_type_id: this.group_type.id,
      parent_id: this.parent ? this.parent.id : '',
      description: this.description,
    };
  }
  getUpdateAttributes(): GroupModelUpdateAttributes {
    return {
      name: this.name,
      code: this.code,
      group_type_id: this.group_type.id,
      parent_id: this.parent ? this.parent.id : '',
      description: this.description,
    };
  }
}
export type GroupCollection = GroupModel[];
export const GroupTableColumns: QTableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    align: 'left',
    field: 'id',
    sortable: true,
  },
  {
    name: 'name',
    label: '名前',
    align: 'left',
    field: 'name',
    sortable: true,
  },
  {
    name: 'code',
    label: '識別コード',
    align: 'left',
    field: 'code',
    sortable: true,
  },
  {
    name: 'created_at',
    label: '作成日',
    align: 'left',
    field: 'created_at',
    sortable: true,
  },
];

// TODO: 仮置き場
export type ChildrenGroupAttributes = {
  id: string;
  name: string;
  updated_at: string;
};
export type ChildrenResourceAttributes = {
  id: string;
  name: string;
  resource_type: {
    id: string;
    name: string;
  };
  updated_at: string;
};
export type GroupsAttributesAndResourcesAttributes = {
  groups: ChildrenGroupAttributes[];
  resources: ChildrenResourceAttributes[];
};
